import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { ConfigEntryType } from 'config/config';
import { AxiosResponse } from 'axios';
import { ConfigResponseType } from '../apis/ConfigAPI';
import { getConfigEntryOptions, getConfigEntryQueryOptions } from '../helpers';

function useConfigEntryOptionsQuery({
  companyId,
  configEntry,
  defaultOptions = [],
  shouldFetch = true,
}: {
  companyId?: string;
  configEntry: ConfigEntryType;
  defaultOptions?: { label: string; value: string }[];
  shouldFetch?: boolean;
}) {
  const { data: queryData, ...rest } = useQuery<
    AxiosResponse<Record<string, any>[] | ConfigResponseType>,
    Error
  >(
    getConfigEntryQueryOptions({
      companyId,
      configEntry,
      shouldFetch,
    }),
  );

  const activeUniqueOrderedOptions = useMemo(
    () => getConfigEntryOptions({ configEntry, defaultOptions, data: queryData?.data }),
    [queryData, configEntry, configEntry.targetMapper, defaultOptions],
  );

  return {
    activeUniqueOrderedOptions,
    ...rest,
  };
}

export default useConfigEntryOptionsQuery;
